/**
 * Rare Diamondss Theme v2.0
 * Main JavaScript
 */

(function() {
  'use strict';

  /* --- Language Switcher (Google Translate powered) --- */
  const langSwitcher = {
    selected: 'en',
    labelMap: {
      en: 'English', ar: 'العربية', fr: 'Français', de: 'Deutsch',
      es: 'Español', ja: '日本語', 'zh-CN': '中文', ko: '한국어',
      pt: 'Português', ru: 'Русский', ms: 'Bahasa Melayu'
    },

    init() {
      this.selected = localStorage.getItem('rd_lang') || 'en';
      this.setupDropdowns();
      this.updateActiveStates();
      this.updateLabels();
      this.guardLabels();

      // Set cookie before Google Translate initializes so it auto-translates
      if (this.selected !== 'en') {
        const domain = location.hostname;
        document.cookie = 'googtrans=/en/' + this.selected + ';path=/;domain=' + domain;
        document.cookie = 'googtrans=/en/' + this.selected + ';path=/';
        this.waitForGoogleTranslate(() => this.setGoogleTranslate(this.selected));
      }
    },

    setupDropdowns() {
      document.querySelectorAll('[data-lang-switcher]').forEach(switcher => {
        const toggle = switcher.querySelector('.lang-switcher__toggle');
        const dropdown = switcher.querySelector('[data-lang-dropdown]');

        if (!toggle || !dropdown) return;

        toggle.addEventListener('click', (e) => {
          e.stopPropagation();
          document.querySelectorAll('[data-lang-dropdown].open, [data-currency-dropdown].open').forEach(d => {
            if (d !== dropdown) d.classList.remove('open');
          });
          dropdown.classList.toggle('open');
          toggle.setAttribute('aria-expanded', dropdown.classList.contains('open'));
        });

        switcher.querySelectorAll('.lang-switcher__option').forEach(opt => {
          opt.addEventListener('click', (e) => {
            e.preventDefault();
            this.selectLanguage(opt.dataset.langCode, opt.textContent.trim());
            dropdown.classList.remove('open');
            toggle.setAttribute('aria-expanded', 'false');
          });
        });
      });

      document.addEventListener('click', (e) => {
        if (!e.target.closest('[data-lang-switcher]')) {
          document.querySelectorAll('[data-lang-dropdown].open').forEach(d => d.classList.remove('open'));
        }
      });
    },

    selectLanguage(code, label, isAuto) {
      this.selected = code;
      localStorage.setItem('rd_lang', code);
      if (!isAuto) sessionStorage.setItem('rd_lang_chosen', '1');
      this.updateActiveStates();
      this.updateLabels();

      if (code === 'en') {
        // Restore original language
        this.removeGoogleTranslate();
      } else {
        this.setGoogleTranslate(code);
      }
    },

    updateActiveStates() {
      document.querySelectorAll('.lang-switcher__option').forEach(opt => {
        opt.classList.toggle('active', opt.dataset.langCode === this.selected);
      });
    },

    updateLabels() {
      const label = this.labelMap[this.selected] || 'English';
      document.querySelectorAll('[data-lang-label]').forEach(el => {
        el.textContent = label;
      });
    },

    guardLabels() {
      // Protect switcher labels from Google Translate mutations
      const observer = new MutationObserver(() => {
        const expected = this.labelMap[this.selected] || 'English';
        document.querySelectorAll('[data-lang-label]').forEach(el => {
          if (el.textContent !== expected) el.textContent = expected;
        });
        document.querySelectorAll('.lang-switcher__option').forEach(opt => {
          const code = opt.dataset.langCode;
          const native = this.labelMap[code];
          if (native && opt.textContent.trim() !== native) opt.textContent = native;
        });
      });
      document.querySelectorAll('[data-lang-switcher]').forEach(switcher => {
        observer.observe(switcher, { childList: true, subtree: true, characterData: true });
      });
    },

    autoDetectFromCountry(countryCode) {
      if (sessionStorage.getItem('rd_lang_chosen') === '1') return;
      if (this.selected !== 'en') return;

      const countryToLang = {
        SA: 'ar', AE: 'ar', QA: 'ar', KW: 'ar', BH: 'ar', OM: 'ar', EG: 'ar',
        FR: 'fr', BE: 'fr', CH: 'fr',
        DE: 'de', AT: 'de',
        ES: 'es', MX: 'es', AR: 'es', CL: 'es', CO: 'es',
        JP: 'ja', CN: 'zh-CN', TW: 'zh-CN', KR: 'ko',
        BR: 'pt', PT: 'pt',
        RU: 'ru', UA: 'ru',
        MY: 'ms'
      };

      const lang = countryToLang[countryCode];
      if (lang) {
        this.selectLanguage(lang, this.labelMap[lang] || lang, true);
      }
    },

    waitForGoogleTranslate(callback, maxAttempts) {
      maxAttempts = maxAttempts || 80;
      let attempts = 0;
      const check = setInterval(() => {
        attempts++;
        const combo = document.querySelector('.goog-te-combo');
        if (combo) {
          clearInterval(check);
          setTimeout(callback, 500);
        } else if (attempts >= maxAttempts) {
          clearInterval(check);
        }
      }, 250);
    },

    setGoogleTranslate(langCode) {
      // Method 1: Use the combo box
      const combo = document.querySelector('.goog-te-combo');
      if (combo) {
        combo.value = langCode;
        combo.dispatchEvent(new Event('change'));
        return;
      }
      // Method 2: Set cookie and reload
      const domain = location.hostname;
      document.cookie = 'googtrans=/en/' + langCode + ';path=/;domain=' + domain;
      document.cookie = 'googtrans=/en/' + langCode + ';path=/';
      location.reload();
    },

    removeGoogleTranslate() {
      // Step 1: Clear all googtrans cookies thoroughly
      const domain = location.hostname;
      const dotDomain = '.' + domain;
      document.cookie = 'googtrans=;path=/;domain=' + domain + ';expires=Thu, 01 Jan 1970 00:00:00 GMT';
      document.cookie = 'googtrans=;path=/;domain=' + dotDomain + ';expires=Thu, 01 Jan 1970 00:00:00 GMT';
      document.cookie = 'googtrans=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT';

      // Step 2: Set explicit /en/en cookie to force English
      document.cookie = 'googtrans=/en/en;path=/;domain=' + domain;
      document.cookie = 'googtrans=/en/en;path=/;domain=' + dotDomain;
      document.cookie = 'googtrans=/en/en;path=/';

      // Step 3: Use combo box if available
      const combo = document.querySelector('.goog-te-combo');
      if (combo) {
        combo.value = 'en';
        combo.dispatchEvent(new Event('change'));
        // Force reload after a short delay to fully clear translation
        setTimeout(() => { location.reload(); }, 500);
        return;
      }

      // Step 4: Try banner restore button
      const iframe = document.querySelector('.goog-te-banner-frame');
      if (iframe) {
        try {
          const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
          const restore = innerDoc.querySelector('.goog-close-link');
          if (restore) {
            restore.click();
            setTimeout(() => { location.reload(); }, 500);
            return;
          }
        } catch(e) {}
      }

      // Step 5: Fallback reload
      location.reload();
    }
  };

  /* --- Mobile Navigation --- */
  const mobileNav = {
    init() {
      const toggle = document.querySelector('.header__menu-toggle');
      const nav = document.querySelector('.mobile-nav');
      const overlay = document.querySelector('.mobile-nav__overlay');
      const close = document.querySelector('.mobile-nav__close');

      if (!toggle || !nav) return;

      toggle.addEventListener('click', () => this.open(nav, overlay));
      if (close) close.addEventListener('click', () => this.close(nav, overlay));
      if (overlay) overlay.addEventListener('click', () => this.close(nav, overlay));
    },

    open(nav, overlay) {
      nav.classList.add('open');
      if (overlay) overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    },

    close(nav, overlay) {
      nav.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  };

  /* --- Cart Drawer --- */
  const cartDrawer = {
    init() {
      this.drawer = document.querySelector('.cart-drawer');
      this.overlay = document.querySelector('.cart-drawer__overlay');
      this.closeBtn = document.querySelector('.cart-drawer__close');

      document.querySelectorAll('[data-cart-toggle]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());
    },

    open() {
      if (!this.drawer) return;
      this.drawer.classList.add('open');
      if (this.overlay) this.overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    },

    close() {
      if (!this.drawer) return;
      this.drawer.classList.remove('open');
      if (this.overlay) this.overlay.classList.remove('open');
      document.body.style.overflow = '';
    },

    async addItem(variantId, quantity = 1) {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
        });
        const item = await response.json();
        this.refreshCart();
        this.open();
        return item;
      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    },

    async updateItem(key, quantity) {
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        const cart = await response.json();
        this.renderCart(cart);
        this.updateCartCount(cart.item_count);
        return cart;
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    },

    async refreshCart() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        this.renderCart(cart);
        this.updateCartCount(cart.item_count);
      } catch (error) {
        console.error('Error fetching cart:', error);
      }
    },

    renderCart(cart) {
      const itemsContainer = document.querySelector('.cart-drawer__items');
      const subtotalEl = document.querySelector('.cart-drawer__subtotal-amount');

      if (!itemsContainer) return;

      if (cart.items.length === 0) {
        itemsContainer.innerHTML = '<p class="cart-drawer__empty">Your cart is empty</p>';
      } else {
        itemsContainer.innerHTML = cart.items.map(item => `
          <div class="cart-drawer__item" data-key="${item.key}">
            <img class="cart-drawer__item-image" src="${item.image}" alt="${item.title}" loading="lazy">
            <div class="cart-drawer__item-info">
              <p class="cart-drawer__item-title">${item.product_title}</p>
              <p class="cart-drawer__item-variant">${item.variant_title || ''}</p>
              <p class="cart-drawer__item-price"><span class="money">${this.formatMoney(item.final_line_price)}</span></p>
              <div class="cart-drawer__quantity">
                <button class="cart-drawer__quantity-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity - 1}">-</button>
                <span class="cart-drawer__quantity-value">${item.quantity}</span>
                <button class="cart-drawer__quantity-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
              </div>
            </div>
          </div>
        `).join('');

        itemsContainer.querySelectorAll('.cart-drawer__quantity-btn').forEach(btn => {
          btn.addEventListener('click', () => {
            this.updateItem(btn.dataset.key, parseInt(btn.dataset.qty));
          });
        });
      }

      if (subtotalEl) {
        subtotalEl.innerHTML = `<span class="money">${this.formatMoney(cart.total_price)}</span>`;
      }
    },

    updateCartCount(count) {
      document.querySelectorAll('.header__cart-count').forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    },

    formatMoney(cents) {
      const amount = cents / 100;
      const fmt2 = amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const fmt0 = Math.floor(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const fmt2comma = amount.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      const fmt0comma = Math.floor(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

      let format = window.Shopify?.moneyFormat || '&#8377;{{amount}}';

      // Strip HTML wrapper (e.g. <span class=money>...</span>) — we only need the text
      format = format.replace(/<[^>]+>/g, '');

      // Decode common HTML entities so symbols render correctly in textContent
      format = format.replace(/&#8377;/g, '₹').replace(/&amp;/g, '&')
                     .replace(/&#36;/g, '$').replace(/&pound;/g, '£')
                     .replace(/&euro;/g, '€').replace(/&yen;/g, '¥');

      // Replace all placeholder variants — match with or without spaces e.g. {{amount}} or {{ amount }}
      format = format.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, fmt0comma);
      format = format.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, fmt2comma);
      format = format.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, fmt0);
      format = format.replace(/\{\{\s*amount\s*\}\}/g, fmt2);

      return format;
    }
  };

  /* --- Product Gallery --- */
  const productGallery = {
    init() {
      // Variant label update
      const infoBar = document.getElementById('gallery-variant-info');
      const form = document.querySelector('[data-product-form]');
      if (infoBar && form) {
        const selects = form.querySelectorAll('[data-variant-option]');
        selects.forEach(sel => {
          sel.addEventListener('change', () => {
            const parts = Array.from(selects).map(s => s.value);
            infoBar.innerHTML = '<span>Selected: ' + parts.join(' | ') + '</span>';
          });
        });
      }

      // Mobile swipe carousel dots
      const grid = document.querySelector('[data-gallery-track]');
      const dotsContainer = document.getElementById('gallery-dots');
      if (!grid || !dotsContainer) return;

      this.initDots(grid, dotsContainer);
    },

    initDots(grid, dotsContainer) {
      dotsContainer.innerHTML = '';
      const visibleItems = Array.from(grid.querySelectorAll('.product-gallery__grid-item'))
        .filter(item => item.style.display !== 'none');

      if (visibleItems.length <= 1) {
        dotsContainer.style.display = 'none';
        return;
      } else {
        dotsContainer.style.display = '';
      }

      // Build dot buttons
      visibleItems.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'product-gallery__dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
        dot.addEventListener('click', () => {
          grid.scrollTo({ left: grid.offsetWidth * i, behavior: 'smooth' });
        });
        dotsContainer.appendChild(dot);
      });

      const dots = dotsContainer.querySelectorAll('.product-gallery__dot');

      if (this.scrollHandler) {
        grid.removeEventListener('scroll', this.scrollHandler);
      }

      this.scrollHandler = () => {
        if (this.scrollTimer) clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          const index = Math.round(grid.scrollLeft / grid.offsetWidth);
          dots.forEach((d, i) => d.classList.toggle('active', i === index));
        }, 50);
      };

      grid.addEventListener('scroll', this.scrollHandler, { passive: true });
    }
  };

  /* --- Size Buttons --- */
  const sizeButtons = {
    init() {
      document.querySelectorAll('.size-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const track = btn.closest('[data-option-track]');
          if (track) {
            track.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
          }
          btn.classList.add('active');

          const optionGroup = btn.closest('[data-option-group]');
          if (optionGroup) {
            const label = optionGroup.querySelector('.product-info__option-selected');
            if (label) label.textContent = btn.dataset.value;
          }

          const optionSelect = document.querySelector(`[data-variant-option="${btn.dataset.optionIndex}"]`);
          if (optionSelect) {
            optionSelect.value = btn.dataset.value;
            optionSelect.dispatchEvent(new Event('change'));
          }
        });
      });
    }
  };

  /* --- Metal Swatches --- */
  const metalSwatches = {
    init() {
      document.querySelectorAll('.metal-swatch').forEach(swatch => {
        swatch.addEventListener('click', () => {
          const track = swatch.closest('[data-option-track]');
          if (track) {
            track.querySelectorAll('.metal-swatch').forEach(s => {
              s.classList.remove('active');
              s.setAttribute('aria-pressed', 'false');
            });
          }
          swatch.classList.add('active');
          swatch.setAttribute('aria-pressed', 'true');

          const optionGroup = swatch.closest('[data-option-group]');
          if (optionGroup) {
            const label = optionGroup.querySelector('.product-info__option-selected');
            if (label) label.textContent = swatch.dataset.value;
          }

          const optionSelect = document.querySelector(`[data-variant-option="${swatch.dataset.optionIndex}"]`);
          if (optionSelect) {
            optionSelect.value = swatch.dataset.value;
            optionSelect.dispatchEvent(new Event('change'));
          }
        });
      });
    }
  };

  /* --- Option Track Arrows --- */
  const optionArrows = {
    init() {
      document.querySelectorAll('.product-info__option-row').forEach(row => {
        const track = row.querySelector('[data-option-track]');
        const prev = row.querySelector('.product-info__option-arrow--prev');
        const next = row.querySelector('.product-info__option-arrow--next');
        if (!track) return;

        const scrollAmount = 120;

        prev?.addEventListener('click', () => {
          track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });

        next?.addEventListener('click', () => {
          track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
      });
    }
  };

  /* --- Wishlist Toggle --- */
  const wishlistToggle = {
    init() {
      document.querySelectorAll('.product-info__wishlist').forEach(btn => {
        btn.addEventListener('click', () => {
          btn.classList.toggle('active');
        });
      });
    }
  };

  /* --- Countdown Timer --- */
  const countdownTimer = {
    init() {
      const el = document.querySelector('[data-countdown]');
      if (!el) return;

      const hours = parseInt(el.dataset.countdown) || 14;
      const now = new Date();
      const endOfDay = new Date(now);
      endOfDay.setHours(hours, 0, 0, 0);

      if (now >= endOfDay) {
        endOfDay.setDate(endOfDay.getDate() + 1);
      }

      const update = () => {
        const diff = endOfDay - new Date();
        if (diff <= 0) {
          el.textContent = '00h : 00m : 00s';
          return;
        }
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        el.textContent = String(h).padStart(2, '0') + 'h : ' + String(m).padStart(2, '0') + 'm : ' + String(s).padStart(2, '0') + 's';
      };

      update();
      setInterval(update, 1000);
    }
  };

  /* --- Collapsible Sections --- */
  const collapsibles = {
    init() {
      document.querySelectorAll('.collapsible__trigger').forEach(trigger => {
        trigger.addEventListener('click', () => {
          const content = trigger.nextElementSibling;
          const isOpen = content.classList.contains('open');

          trigger.setAttribute('aria-expanded', !isOpen);
          content.classList.toggle('open');

          if (!isOpen) {
            content.style.maxHeight = content.scrollHeight + 'px';
          } else {
            content.style.maxHeight = '0';
          }
        });
      });
    }
  };

  /* --- Tabs --- */
  const tabs = {
    init() {
      document.querySelectorAll('[data-tabs]').forEach(tabGroup => {
        const buttons = tabGroup.querySelectorAll('.tab-btn');
        const contents = tabGroup.querySelectorAll('.tab-content');

        buttons.forEach(btn => {
          btn.addEventListener('click', () => {
            const target = btn.dataset.tab;

            buttons.forEach(b => b.classList.remove('active'));
            contents.forEach(c => c.classList.remove('active'));

            btn.classList.add('active');
            const targetContent = tabGroup.querySelector(`[data-tab-content="${target}"]`);
            if (targetContent) targetContent.classList.add('active');
          });
        });
      });
    }
  };

  /* --- Collection Tabs --- */
  const collectionTabs = {
    init() {
      document.querySelectorAll('.collection-tab').forEach(tab => {
        tab.addEventListener('click', () => {
          const parent = tab.closest('.section');
          if (!parent) return;

          parent.querySelectorAll('.collection-tab').forEach(t => t.classList.remove('active'));
          tab.classList.add('active');

          const target = tab.dataset.collection;
          parent.querySelectorAll('.collection-tab-content').forEach(content => {
            content.style.display = content.dataset.collection === target ? 'block' : 'none';
          });
        });
      });
    }
  };

  /* --- Product Form --- */
  const productForm = {
    init() {
      const form = document.querySelector('[data-product-form]');
      if (!form) return;

      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const submitBtn = form.querySelector('[type="submit"]');
        const originalText = submitBtn.textContent;
        submitBtn.textContent = 'Adding...';
        submitBtn.disabled = true;

        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity') || '1');

        await cartDrawer.addItem(variantId, quantity);

        submitBtn.textContent = 'Added!';
        setTimeout(() => {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 2000);
      });

      // Variant selection
      void this.initVariantSelector(form);
    },

    async initVariantSelector(form) {
      const variantSelects = form.querySelectorAll('[data-variant-option]');
      const variantIdInput = form.querySelector('[name="id"]');
      const variantsJson = form.querySelector('[data-product-variants]');

      if (!variantsJson || !variantIdInput) return;

      let variants;
      try {
        variants = JSON.parse(variantsJson.textContent);
      } catch (e) {
        return;
      }

      const metalSelect = this.getMetalSelect(form);

      await this.buildGalleryMetalTags(form, variants);

      // Sync gallery on page load
      const selectedOptions = Array.from(variantSelects).map(s => s.value);
      const matchedVariant = variants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );
      if (matchedVariant) {
        this.updateGalleryByMetal(metalSelect ? metalSelect.value : null);
      }

      variantSelects.forEach(select => {
        select.addEventListener('change', () => {
          const selectedOptions = Array.from(variantSelects).map(s => s.value);
          const matchedVariant = variants.find(v =>
            v.options.every((opt, i) => opt === selectedOptions[i])
          );

          if (matchedVariant) {
            variantIdInput.value = matchedVariant.id;
            this.updatePrice(matchedVariant);
            this.updateAvailability(matchedVariant, form);

            if (metalSelect && select === metalSelect) {
              this.updateGalleryByMetal(metalSelect.value);
            }
          }
        });
      });
    },

    getMetalSelect(form) {
      const root = form || document.querySelector('[data-product-form]');
      if (!root) return null;

      return Array.from(root.querySelectorAll('[data-variant-option]')).find(select => {
        const name = (select.getAttribute('aria-label') || '').toLowerCase();
        return name.includes('metal') || name.includes('gold') || name.includes('karat');
      }) || null;
    },

    getGalleryConfig(form) {
      const configEl = (form || document).querySelector('[data-gallery-config]');
      if (!configEl) return null;
      try {
        return JSON.parse(configEl.textContent);
      } catch (e) {
        return null;
      }
    },

    getMetalFromVariant(variant, metalOptionIndex) {
      if (!variant || metalOptionIndex < 0) return null;
      return variant.options ? variant.options[metalOptionIndex] : null;
    },

    getColorKeyword(value) {
      const lower = (value || '').toLowerCase();
      if (lower.includes('yellow')) return 'yellow';
      if (lower.includes('white')) return 'white';
      if (lower.includes('rose')) return 'rose';
      if (lower.includes('platinum')) return 'platinum';
      return null;
    },

    imageMatchesMetal(alt, metalValue) {
      const altLower = (alt || '').toLowerCase();
      const metalLower = (metalValue || '').toLowerCase();
      if (!altLower || !metalLower) return false;
      if (altLower.includes(metalLower)) return true;

      const colorWord = this.getColorKeyword(metalLower);
      return colorWord ? altLower.includes(colorWord) : false;
    },

    addMetalToMap(map, imageKey, metal) {
      if (!imageKey || !metal) return;
      if (!map.has(imageKey)) map.set(imageKey, new Set());
      map.get(imageKey).add(metal);
    },

    applyMetalMapToGallery(metalMap) {
      const items = Array.from(document.querySelectorAll('[data-gallery-track] .product-gallery__grid-item'));
      items.forEach(item => {
        const imageId = item.dataset.imageId;
        const metals = metalMap.get(imageId);
        if (metals && metals.size > 0) {
          item.dataset.metals = Array.from(metals).join('|');
        } else {
          delete item.dataset.metals;
        }
      });
    },

    async buildGalleryMetalTags(form, variants) {
      const config = this.getGalleryConfig(form);
      if (!config || config.metalOptionIndex < 0) return;

      const metalOptionIndex = config.metalOptionIndex;
      const metalValues = config.metalValues || [];
      const items = Array.from(document.querySelectorAll('[data-gallery-track] .product-gallery__grid-item'));
      if (items.length === 0 || metalValues.length === 0) return;

      const metalMap = new Map();
      const variantById = new Map(variants.map(v => [String(v.id), v]));
      // Unique featured-image IDs per metal (from Shopify variant assignments)
      const featuredByMetal = new Map(metalValues.map(m => [m, new Set()]));

      const resolveImageId = (featuredImage) => {
        if (!featuredImage) return null;
        if (featuredImage.id) {
          const byId = items.find(el => String(el.dataset.imageId) === String(featuredImage.id));
          if (byId) return String(byId.dataset.imageId);
        }
        // Fallback: match by src when IDs don't line up
        const src = (featuredImage.src || '').split('?')[0].replace(/^https?:/, '');
        if (!src) return featuredImage.id ? String(featuredImage.id) : null;
        const bySrc = items.find(el => {
          const img = el.querySelector('.product-gallery__img');
          if (!img) return false;
          const imgSrc = (img.currentSrc || img.src || '').split('?')[0].replace(/^https?:/, '');
          return imgSrc.includes(src) || src.includes(imgSrc);
        });
        return bySrc ? String(bySrc.dataset.imageId) : (featuredImage.id ? String(featuredImage.id) : null);
      };

      // 1. Collect featured images from every variant (source of truth)
      variants.forEach(variant => {
        const metal = this.getMetalFromVariant(variant, metalOptionIndex);
        if (!metal || !featuredByMetal.has(metal)) return;
        const imageId = resolveImageId(variant.featured_image);
        if (!imageId) return;
        featuredByMetal.get(metal).add(imageId);
        this.addMetalToMap(metalMap, imageId, metal);
      });

      // 2. Also map product.js variant_ids → metal (extra links in admin)
      const gallery = document.querySelector('[data-product-gallery]');
      const handle = gallery?.dataset.productHandle;
      if (handle) {
        try {
          const response = await fetch(`/products/${handle}.js`);
          if (response.ok) {
            const product = await response.json();
            const images = Array.isArray(product.media)
              ? product.media.filter(m => m.media_type === 'image' || m.preview_image)
              : (product.images || []);

            images.forEach(image => {
              if (!image || typeof image !== 'object') return;
              const imageId = String(image.id || image.preview_image?.id || '');
              if (!imageId) return;

              (image.variant_ids || []).forEach(variantId => {
                const variant = variantById.get(String(variantId));
                const metal = this.getMetalFromVariant(variant, metalOptionIndex);
                if (!metal) return;
                // Only add if this metal is NOT already in strict mode from featured images.
                // Never inflate a strict featured set via loose variant_ids links.
                if ((featuredByMetal.get(metal)?.size || 0) >= 2) return;
                this.addMetalToMap(metalMap, imageId, metal);
              });
            });
          }
        } catch (e) {
          // ignore
        }
      }

      // 3. STRICT metals (2+ assigned images): remove this metal from every
      //    other image so shared/block logic can never add a 3rd photo
      const strictMetals = new Set();
      metalValues.forEach(metal => {
        const featured = featuredByMetal.get(metal);
        if (!featured || featured.size < 2) return;
        strictMetals.add(metal);
        metalMap.forEach((metals, imageId) => {
          if (metals.has(metal) && !featured.has(imageId)) {
            metals.delete(metal);
          }
        });
        featured.forEach(imageId => this.addMetalToMap(metalMap, imageId, metal));
      });

      // 4. BLOCK mode — only for metals with 0 or 1 assigned image
      const blockMetals = metalValues.filter(m => !strictMetals.has(m));
      if (blockMetals.length > 0) {
        const anchors = [];
        metalValues.forEach(metal => {
          let minPos = Infinity;
          items.forEach((item, i) => {
            const metals = metalMap.get(item.dataset.imageId);
            if (metals && metals.has(metal) && i < minPos) minPos = i;
          });
          if (minPos !== Infinity) anchors.push({ metal, position: minPos });
        });
        anchors.sort((a, b) => a.position - b.position);

        anchors.forEach((anchor, index) => {
          if (!blockMetals.includes(anchor.metal)) return;
          const start = anchor.position;
          const end = index + 1 < anchors.length
            ? anchors[index + 1].position - 1
            : items.length - 1;

          for (let i = start; i <= end; i++) {
            const imageId = items[i]?.dataset.imageId;
            if (!imageId) continue;
            // Don't steal images that belong to a strict metal set
            const already = metalMap.get(imageId);
            const belongsToStrict = already && Array.from(already).some(m => strictMetals.has(m));
            if (belongsToStrict) continue;
            this.addMetalToMap(metalMap, imageId, anchor.metal);
          }
        });
      }

      // 5. Alt-text fallback only for images still with no metal at all
      items.forEach(item => {
        const imageId = item.dataset.imageId;
        if (!imageId) return;
        if (metalMap.has(imageId) && metalMap.get(imageId).size > 0) return;

        const img = item.querySelector('.product-gallery__img');
        const alt = img?.alt || '';
        metalValues.forEach(metal => {
          // Never alt-tag onto a strict metal (would inflate the count)
          if (strictMetals.has(metal)) return;
          if (this.imageMatchesMetal(alt, metal)) {
            this.addMetalToMap(metalMap, imageId, metal);
          }
        });
      });

      // Final pass: re-assert strict sets so nothing leaked in
      strictMetals.forEach(metal => {
        const featured = featuredByMetal.get(metal);
        metalMap.forEach((metals, imageId) => {
          if (metals.has(metal) && !featured.has(imageId)) metals.delete(metal);
        });
        featured.forEach(imageId => this.addMetalToMap(metalMap, imageId, metal));
      });

      // Expose strict sets for the filter step
      if (gallery) {
        const strictPayload = {};
        strictMetals.forEach(metal => {
          strictPayload[metal] = Array.from(featuredByMetal.get(metal));
        });
        gallery.dataset.strictMetalImages = JSON.stringify(strictPayload);
      }

      this.applyMetalMapToGallery(metalMap);
    },

    updateGalleryByMetal(selectedMetal) {
      const grid = document.querySelector('[data-gallery-track]');
      if (!grid) return;

      const items = Array.from(grid.querySelectorAll('.product-gallery__grid-item'));
      if (items.length === 0) return;

      if (!selectedMetal) {
        items.forEach(item => { item.style.display = ''; });
        this.refreshGalleryUI(grid);
        return;
      }

      // Hard filter: if this metal has a strict assigned set, show ONLY those IDs
      const gallery = document.querySelector('[data-product-gallery]');
      let strictIds = null;
      try {
        const payload = gallery?.dataset.strictMetalImages
          ? JSON.parse(gallery.dataset.strictMetalImages)
          : null;
        if (payload && Array.isArray(payload[selectedMetal]) && payload[selectedMetal].length >= 2) {
          strictIds = new Set(payload[selectedMetal].map(String));
        }
      } catch (e) {
        strictIds = null;
      }

      if (strictIds) {
        items.forEach(item => {
          item.style.display = strictIds.has(String(item.dataset.imageId)) ? '' : 'none';
        });
        this.refreshGalleryUI(grid);
        return;
      }

      const metalSpecificItems = items.filter(item => {
        const metals = (item.dataset.metals || '').split('|').filter(Boolean);
        return metals.includes(selectedMetal);
      });

      if (metalSpecificItems.length > 0) {
        items.forEach(item => {
          const metals = (item.dataset.metals || '').split('|').filter(Boolean);
          item.style.display = metals.includes(selectedMetal) ? '' : 'none';
        });
      } else {
        items.forEach(item => { item.style.display = ''; });
      }

      this.refreshGalleryUI(grid);
    },

    refreshGalleryUI(grid) {
      const dotsContainer = document.getElementById('gallery-dots');
      if (dotsContainer) {
        productGallery.initDots(grid, dotsContainer);
      }
      grid.scrollLeft = 0;
    },

    updatePrice(variant) {
      const priceEl = document.querySelector('.product-info__price');
      const compareEl = document.querySelector('.product-info__compare-price');
      const discountEl = document.querySelector('.product-info__discount-badge');
      const buyAmount = document.querySelector('.product-info__buy-amount');
      const buyCompare = document.querySelector('.product-info__buy-compare');

      // Use innerHTML + <span class="money"> so BUCKS can locate and convert the price
      const moneyHtml = (cents) => `<span class="money">${cartDrawer.formatMoney(cents)}</span>`;

      if (priceEl) priceEl.innerHTML = moneyHtml(variant.price);
      if (buyAmount) buyAmount.innerHTML = moneyHtml(variant.price);

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (compareEl) { compareEl.innerHTML = moneyHtml(variant.compare_at_price); compareEl.style.display = ''; }
        if (buyCompare) { buyCompare.innerHTML = moneyHtml(variant.compare_at_price); buyCompare.style.display = ''; }
        if (discountEl) {
          const pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          discountEl.textContent = '(' + pct + '% OFF)';
          discountEl.style.display = '';
        }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (buyCompare) buyCompare.style.display = 'none';
        if (discountEl) discountEl.style.display = 'none';
      }

      // Notify BUCKS after DOM settles so it can find the new .money spans
      setTimeout(() => this._notifyCurrencyApp(), 50);
    },

    _notifyCurrencyApp() {
      // BUCKS Currency Converter refresh hooks
      if (window.BUCKS && typeof window.BUCKS.convert === 'function') {
        window.BUCKS.convert();
        return;
      }
      if (window.BUCKS && typeof window.BUCKS.refresh === 'function') {
        window.BUCKS.refresh();
        return;
      }
      // Generic fallback events that most currency apps listen to
      document.dispatchEvent(new CustomEvent('bucks:convert'));
      document.dispatchEvent(new CustomEvent('currency:refresh'));
    },

    updateAvailability(variant, form) {
      const submitBtn = form.querySelector('[type="submit"]');
      if (!submitBtn) return;

      if (variant.available) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'ADD TO BAG';
      } else {
        submitBtn.disabled = true;
        submitBtn.textContent = 'SOLD OUT';
      }
    }
  };

  /* --- Quantity Selector --- */
  const quantitySelector = {
    init() {
      document.querySelectorAll('.quantity-selector').forEach(selector => {
        const input = selector.querySelector('.quantity-selector__input');
        const decrease = selector.querySelector('[data-action="decrease"]');
        const increase = selector.querySelector('[data-action="increase"]');

        if (!input) return;

        decrease?.addEventListener('click', () => {
          const val = parseInt(input.value) || 1;
          if (val > 1) input.value = val - 1;
        });

        increase?.addEventListener('click', () => {
          const val = parseInt(input.value) || 1;
          input.value = val + 1;
        });
      });
    }
  };

  /* --- Color Swatches (legacy support) --- */
  const colorSwatches = {
    init() {
      document.querySelectorAll('.color-swatch').forEach(swatch => {
        swatch.addEventListener('click', () => {
          const group = swatch.closest('.product-info__color-swatches') || swatch.closest('[data-option-track]');
          if (group) {
            group.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('active'));
          }
          swatch.classList.add('active');

          const optionGroup = swatch.closest('[data-option-group]');
          if (optionGroup) {
            const label = optionGroup.querySelector('.product-info__option-selected');
            if (label) label.textContent = swatch.dataset.value;
          }

          const optionSelect = document.querySelector(`[data-variant-option="${swatch.dataset.optionIndex}"]`);
          if (optionSelect) {
            optionSelect.value = swatch.dataset.value;
            optionSelect.dispatchEvent(new Event('change'));
          }
        });
      });
    }
  };

  /* --- Metal Options (legacy support) --- */
  const metalOptions = {
    init() {
      document.querySelectorAll('.metal-option').forEach(option => {
        option.addEventListener('click', () => {
          const group = option.closest('.product-info__metal-options');
          if (group) {
            group.querySelectorAll('.metal-option').forEach(o => o.classList.remove('active'));
          }
          option.classList.add('active');

          const optionSelect = document.querySelector(`[data-variant-option="${option.dataset.optionIndex}"]`);
          if (optionSelect) {
            optionSelect.value = option.dataset.value;
            optionSelect.dispatchEvent(new Event('change'));
          }
        });
      });
    }
  };

  /* --- Pledge Tags + Slideshow --- */
  const pledgeTags = {
    _timer: null,
    _delay: 3000,

    init() {
      const section = document.querySelector('.pledge-section');
      if (!section) return;

      const tags = section.querySelectorAll('.pledge-tag');
      const slides = section.querySelectorAll('[data-pledge-slide]');
      const dots = section.querySelectorAll('[data-pledge-dot]');
      const self = this;

      const goTo = (index) => {
        tags.forEach(t => t.classList.remove('active'));
        slides.forEach(s => s.classList.remove('active'));
        dots.forEach(d => d.classList.remove('active'));

        const tag = section.querySelector(`[data-pledge-index="${index}"]`);
        const slide = section.querySelector(`[data-pledge-slide="${index}"]`);
        const dot = section.querySelector(`[data-pledge-dot="${index}"]`);

        if (tag) tag.classList.add('active');
        if (slide) slide.classList.add('active');
        if (dot) dot.classList.add('active');

        const number = section.querySelector('.pledge-section__number');
        const subtitle = section.querySelector('.pledge-section__subtitle');
        if (number && tag) number.textContent = tag.dataset.number;
        if (subtitle && tag) subtitle.textContent = tag.dataset.description || '';

        // Reset inner slideshow to first image
        if (slide) self._resetInner(slide);
        self._startInner(slide);
      };

      tags.forEach(tag => {
        tag.addEventListener('click', () => goTo(tag.dataset.pledgeIndex));
      });

      dots.forEach(dot => {
        dot.addEventListener('click', () => goTo(dot.dataset.pledgeDot));
      });

      // Click on pips to jump to that inner image
      section.querySelectorAll('.pledge-slide__pip').forEach(pip => {
        pip.addEventListener('click', () => {
          const slide = pip.closest('.pledge-slide');
          if (slide) {
            self._showFrame(slide, parseInt(pip.dataset.pip, 10));
            self._startInner(slide);
          }
        });
      });

      // Start auto-rotate on the initially active slide
      const activeSlide = section.querySelector('.pledge-slide.active');
      if (activeSlide) this._startInner(activeSlide);
    },

    _resetInner(slide) {
      this._showFrame(slide, 0);
    },

    _showFrame(slide, idx) {
      const frames = slide.querySelectorAll('[data-slide-frame]');
      const pips = slide.querySelectorAll('[data-pip]');
      frames.forEach(f => f.classList.remove('active'));
      pips.forEach(p => p.classList.remove('active'));
      const frame = slide.querySelector(`[data-slide-frame="${idx}"]`);
      const pip = slide.querySelector(`[data-pip="${idx}"]`);
      if (frame) frame.classList.add('active');
      if (pip) pip.classList.add('active');
    },

    _startInner(slide) {
      clearInterval(this._timer);
      if (!slide) return;
      const count = parseInt(slide.dataset.imgCount, 10) || 0;
      if (count <= 1) return;

      const self = this;
      this._timer = setInterval(() => {
        const current = slide.querySelector('[data-slide-frame].active');
        const idx = current ? parseInt(current.dataset.slideFrame, 10) : 0;
        const next = (idx + 1) % count;
        self._showFrame(slide, next);
      }, this._delay);
    }
  };

  /* --- Sticky Header --- */
  const stickyHeader = {
    init() {
      const header = document.querySelector('.site-header');
      if (!header) return;

      let lastScroll = 0;

      window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;

        if (currentScroll > 100) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }

        lastScroll = currentScroll;
      }, { passive: true });
    }
  };

  /* --- Collection Grid Toggle --- */
  const collectionGrid = {
    init() {
      const grid = document.getElementById('product-grid');
      const btns = document.querySelectorAll('.collection-toolbar__grid-btn');
      if (!grid || !btns.length) return;

      btns.forEach(btn => {
        btn.addEventListener('click', () => {
          btns.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          const cols = btn.dataset.grid;
          grid.classList.remove('collection-grid--2', 'collection-grid--3');
          grid.classList.add('collection-grid--' + cols);
        });
      });
    }
  };

  /* --- Collection Sort --- */
  const collectionSort = {
    init() {
      const select = document.getElementById('sort-by');
      if (!select) return;
      select.addEventListener('change', () => {
        window.location.href = select.value;
      });
    }
  };

  /* --- Collection Filter Toggle --- */
  const collectionFilter = {
    init() {
      const btn = document.getElementById('filter-toggle');
      const drawer = document.getElementById('filter-drawer');
      if (!btn || !drawer) return;

      btn.addEventListener('click', () => {
        const isOpen = drawer.style.display !== 'none';
        drawer.style.display = isOpen ? 'none' : 'flex';
      });
    }
  };

  /* --- Recently Viewed Products --- */
  const recentlyViewed = {
    storageKey: 'rd_recently_viewed',
    maxItems: 6,

    init() {
      this.trackProduct();
      this.renderGrid();
    },

    trackProduct() {
      if (document.querySelector('.product-page') || document.querySelector('.product-template')) {
        const card = document.querySelector('[data-product-json]');
        if (!card) {
          const url = window.location.pathname;
          const title = document.querySelector('.product-info__title, .product-page h1');
          const img = document.querySelector('.product-gallery__main img, .product-page img');
          const price = document.querySelector('.product-info__price .amount, .product-page .price');
          if (title) {
            const item = {
              url: url,
              title: title.textContent.trim(),
              image: img ? img.src : '',
              price: price ? price.textContent.trim() : '',
              id: url
            };
            this.addToStorage(item);
          }
          return;
        }
      }
    },

    addToStorage(item) {
      let items = this.getItems();
      items = items.filter(i => i.url !== item.url);
      items.unshift(item);
      if (items.length > this.maxItems) items = items.slice(0, this.maxItems);
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(items));
      } catch(e) { /* storage full */ }
    },

    getItems() {
      try {
        return JSON.parse(localStorage.getItem(this.storageKey)) || [];
      } catch(e) {
        return [];
      }
    },

    renderGrid() {
      const section = document.getElementById('recently-viewed-section');
      const grid = document.getElementById('recently-viewed-grid');
      if (!section || !grid) return;

      const items = this.getItems();
      const currentUrl = window.location.pathname;
      const filtered = items.filter(i => i.url !== currentUrl).slice(0, 3);

      if (filtered.length === 0) return;

      section.style.display = 'block';
      grid.innerHTML = filtered.map(item => `
        <div class="product-card">
          <div class="product-card__image-wrapper">
            <a href="${this.escapeHtml(item.url)}" aria-label="${this.escapeHtml(item.title)}">
              ${item.image ? `<img src="${this.escapeHtml(item.image)}" alt="${this.escapeHtml(item.title)}" class="product-card__image" loading="lazy" width="400" height="500">` : '<div class="product-card__placeholder"></div>'}
            </a>
          </div>
          <div class="product-card__info">
            <h3 class="product-card__title">
              <a href="${this.escapeHtml(item.url)}">${this.escapeHtml(item.title)}</a>
            </h3>
            ${item.price ? `<div class="product-card__price"><span>${this.escapeHtml(item.price)}</span></div>` : ''}
          </div>
        </div>
      `).join('');
    },

    escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }
  };

  /* --- Predictive Search --- */
  const predictiveSearch = {
    overlay: null,
    input: null,
    results: null,
    clearBtn: null,
    debounceTimer: null,
    cache: {},

    init() {
      this.overlay = document.querySelector('[data-search-overlay]');
      this.input = document.querySelector('[data-search-input]');
      this.results = document.querySelector('[data-search-results]');
      this.clearBtn = document.querySelector('[data-search-clear]');
      if (!this.overlay || !this.input) return;

      // Open search
      document.querySelectorAll('[data-search-toggle]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      // Close search
      document.querySelectorAll('[data-search-close]').forEach(btn => {
        btn.addEventListener('click', () => this.close());
      });

      // ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.overlay.classList.contains('is-active')) {
          this.close();
        }
      });

      // Input handler with debounce
      this.input.addEventListener('input', () => {
        const query = this.input.value.trim();
        this.clearBtn.style.display = query.length > 0 ? 'flex' : 'none';
        clearTimeout(this.debounceTimer);
        if (query.length < 2) {
          this.showEmptyState();
          return;
        }
        this.debounceTimer = setTimeout(() => this.search(query), 300);
      });

      // Clear button
      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', () => {
          this.input.value = '';
          this.clearBtn.style.display = 'none';
          this.showEmptyState();
          this.input.focus();
        });
      }

      // Form submit - go to full search page
      const form = this.overlay.querySelector('.search-overlay__form');
      if (form) {
        form.addEventListener('submit', (e) => {
          const query = this.input.value.trim();
          if (!query) e.preventDefault();
        });
      }
    },

    open() {
      this.overlay.classList.add('is-active');
      this.overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(() => this.input.focus(), 100);
    },

    close() {
      this.overlay.classList.remove('is-active');
      this.overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },

    showEmptyState() {
      this.results.innerHTML = `
        <div class="search-overlay__empty-state">
          <p class="search-overlay__hint">Start typing to search our collection</p>
        </div>
      `;
    },

    showLoading() {
      this.results.innerHTML = `
        <div class="search-overlay__loading">Searching...</div>
      `;
    },

    async search(query) {
      if (this.cache[query]) {
        this.renderResults(query, this.cache[query]);
        return;
      }

      this.showLoading();

      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor`;
        const response = await fetch(url);
        if (!response.ok) throw new Error('Search failed');
        const data = await response.json();
        const products = data.resources?.results?.products || [];
        this.cache[query] = products;
        this.renderResults(query, products);
      } catch (err) {
        this.results.innerHTML = `
          <div class="search-overlay__no-results">
            <p>Something went wrong. Please try again.</p>
          </div>
        `;
      }
    },

    renderResults(query, products) {
      if (products.length === 0) {
        this.results.innerHTML = `
          <div class="search-overlay__no-results">
            <p>No results found for "${this.escapeHtml(query)}"</p>
          </div>
        `;
        return;
      }

      const productsHtml = products.map(product => {
        const image = product.image ? product.image.replace(/(\.\w+)\?/, '_200x$1?') : '';
        const price = this.formatMoney(product.price);
        const comparePrice = product.compare_at_price_max && parseFloat(product.compare_at_price_max) > parseFloat(product.price)
          ? `<span class="search-overlay__compare-price">${this.formatMoney(product.compare_at_price_max)}</span>`
          : '';
        return `
          <a href="${product.url}" class="search-overlay__product">
            <div class="search-overlay__product-image">
              ${image ? `<img src="${image}" alt="${this.escapeHtml(product.title)}" loading="lazy">` : ''}
            </div>
            <div class="search-overlay__product-info">
              <h4 class="search-overlay__product-title">${this.escapeHtml(product.title)}</h4>
              <div class="search-overlay__product-price">${price}${comparePrice}</div>
            </div>
          </a>
        `;
      }).join('');

      this.results.innerHTML = `
        <p class="search-overlay__products-heading">Products</p>
        <div class="search-overlay__products-grid">${productsHtml}</div>
        <a href="/search?q=${encodeURIComponent(query)}" class="search-overlay__view-all">View all results</a>
      `;
    },

    formatMoney(cents) {
      return cartDrawer.formatMoney(parseFloat(cents));
    },

    escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }
  };

  /* --- Initialize --- */
  document.addEventListener('DOMContentLoaded', () => {
    mobileNav.init();
    langSwitcher.init();
    cartDrawer.init();
    productGallery.init();
    collapsibles.init();
    tabs.init();
    collectionTabs.init();
    productForm.init();
    quantitySelector.init();
    colorSwatches.init();
    metalOptions.init();
    metalSwatches.init();
    sizeButtons.init();
    optionArrows.init();
    wishlistToggle.init();
    countdownTimer.init();
    pledgeTags.init();
    stickyHeader.init();
    predictiveSearch.init();
    collectionGrid.init();
    collectionSort.init();
    collectionFilter.init();
    recentlyViewed.init();

    // Refresh cart count on load
    cartDrawer.refreshCart();

    // Global scroll-reveal animations
    (function(){
      var revealEls = document.querySelectorAll('[data-reveal],[data-reveal-stagger]');
      if (!revealEls.length) return;
      var obs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            obs.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function(el){ obs.observe(el); });
    })();
  });
})();
